import { render, staticRenderFns } from "./SubmitForm19.vue?vue&type=template&id=2be92b36&scoped=true"
import script from "./SubmitForm19.vue?vue&type=script&lang=ts"
export * from "./SubmitForm19.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be92b36",
  null
  
)

export default component.exports